export default "__VITE_ASSET__Bi0VfET5__"